<template>
  <div style="width:100%">
    <v-combobox
      :items="currentTasks"
      :search-input.sync="search"
      label="select or insert"
      v-model="selection"
      :no-filter="true"
      chips
    >
      <template v-slot:item="{ item }">
        <div @keydown="selectItem(item)">{{ item.title }}</div>
      </template>
    </v-combobox>
  </div>
</template>

<script>
import * as api from "./api";

export default {
  name: "TaskPicker",
  components: {},
  props: {
    searcher: Object,
  },
  data: () => ({
    selection: undefined,
    search: "",
    tasks: [],
    currentTasks: [],
  }),
  watch: {
    selection: function () {
      console.log("selection changed");
      if (this.selection === "") {
        return;
      }
      if (this.selection) {
        const persist = async () => {
          if (!this.selection.id) {
            const newTask = await api.createNewTask(this.searcher.boardId, {
              title: this.selection.trim(),
              description: "",
              boardId: this.searcher.boardId,
            });
            setTimeout(() => {
              this.$emit("taskSelected", newTask);
            }, 500);
            this.selection = "";
            this.search = "";
          } else {
            console.log("submitting old task");
            setTimeout(() => {
              this.$emit("taskSelected", this.selection);
              this.selection = "";
              this.search = "";
            }, 500);
          }
        };
        persist();
      }
    },
    search: function () {
      console.log("search changed");
      if (this.search) {
        const _tasks = this.searcher.search(this.search);
        console.log(this.search, this.currentTasks);
        this.currentTasks = _tasks.map((i) =>
          this.searcher.originalSet.find((t) => t.id === i)
        );
      } else {
        return [];
      }
    },
  },
  computed: {},
  methods: {},
};
</script>
